export enum CommonRouteNames {
  Error = 'Error',
  ErrorToken = 'ErrorToken',
  ExpiredToken = 'ExpiredToken',
  Home = 'Home',
  LicenseExpired = 'LicenseExpired',
  Login = 'Login',
  NetworkError = 'NetworkError',
  NotFound = 'NotFound',
  NotFoundAlgorithm = 'NotFoundAlgorithm',
  SessionExpired = 'SessionExpired',
  SignUp = 'SignUp',
  TermsAndConditions = 'TermsAndConditions'
}
